import { isEmpty } from 'lodash';
import { FileText, X } from 'lucide-react';

interface Props {
    selectedFiles: File[];
    onFilesChange: (files: File[]) => void;
    title?: string;
    description?: string;
}

export function SelectedFilesList({
    selectedFiles,
    onFilesChange,
    title = 'Selected Files',
    description,
}: Props) {
    return (
        <div className="space-y-2" data-testid="FileUpload__selectedFiles">
            {!isEmpty(selectedFiles) && (
                <div>
                    <h4 className="font-medium text-gray-900">{title}</h4>
                    {description && (
                        <p className="text-xs text-gray-500">{description}</p>
                    )}
                </div>
            )}
            {Array.from(selectedFiles).map((file) => {
                const fileSize = `${(file.size / 1024 / 1024).toFixed(2)} MB`;
                return (
                    <div
                        key={`${file.name}-${file.size}-${file.lastModified}`}
                        data-testid="FileUpload__selectedFile"
                        className="flex items-center gap-2 rounded-lg border border-[#cbe1e1] bg-white px-3 py-2"
                    >
                        <FileText className="h-4 w-4 shrink-0 text-primary" />
                        <p
                            className="min-w-0 flex-1 truncate text-sm font-medium text-[#1e3b3b]"
                            data-testid="FileUpload__selectedFileName"
                        >
                            {file.name}
                        </p>
                        <p
                            className="shrink-0 text-xs text-muted-foreground"
                            data-testid="FileUpload__selectedFileSize"
                        >
                            {fileSize}
                        </p>
                        <X
                            onClick={() => {
                                onFilesChange(
                                    selectedFiles.filter((f) => f !== file),
                                );
                            }}
                            className="h-4 w-4 shrink-0 cursor-pointer text-muted-foreground hover:text-destructive"
                            data-testid="FileUpload__removeFile"
                        />
                    </div>
                );
            })}
        </div>
    );
}
